import { useLayoutEffect, useState } from "react";

// The visual viewport also follows mobile browser controls and the keyboard.
const readViewport = () => {
  const viewport = window.visualViewport;
  return {
    width: viewport?.width ?? window.innerWidth,
    height: viewport?.height ?? window.innerHeight,
    top: viewport?.offsetTop ?? 0,
    left: viewport?.offsetLeft ?? 0,
  };
};

export default function useChatViewport(enabled) {
  const [viewport, setViewport] = useState(readViewport);

  useLayoutEffect(() => {
    if (!enabled) return;

    let frame;
    const update = () => {
      const next = readViewport();
      setViewport((previous) =>
        previous.width === next.width &&
        previous.height === next.height &&
        previous.top === next.top &&
        previous.left === next.left
          ? previous
          : next,
      );
    };
    const scheduleUpdate = () => {
      window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(update);
    };
    const visualViewport = window.visualViewport;

    // Refresh before paint when reopening after a resize while closed.
    update();
    window.addEventListener("resize", scheduleUpdate);
    visualViewport?.addEventListener("resize", scheduleUpdate);
    visualViewport?.addEventListener("scroll", scheduleUpdate);
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener("resize", scheduleUpdate);
      visualViewport?.removeEventListener("resize", scheduleUpdate);
      visualViewport?.removeEventListener("scroll", scheduleUpdate);
    };
  }, [enabled]);

  return viewport;
}
